import { useEffect, useRef } from 'react'

export default function Hero() {
  const canvasRef = useRef<HTMLCanvasElement>(null)

  useEffect(() => {
    const canvas = canvasRef.current
    if (!canvas) return
    const ctx = canvas.getContext('2d')
    if (!ctx) return

    let raf = 0
    let t = 0
    const dpr = window.devicePixelRatio || 1

    function resize() {
      if (!canvas) return
      canvas.width = canvas.clientWidth * dpr
      canvas.height = canvas.clientHeight * dpr
    }
    resize()
    window.addEventListener('resize', resize)

    const N = 800
    const pts = Array.from({ length: N }, () => ({
      r: 0.6 + Math.random() * 0.4,
      theta: Math.random() * Math.PI * 2,
      phi: Math.acos(2 * Math.random() - 1),
      hue: 220 + Math.random() * 80,
    }))

    function frame() {
      if (!canvas || !ctx) return
      const w = canvas.width
      const h = canvas.height
      const cx = w / 2
      const cy = h / 2
      const scale = Math.min(w, h) * 0.32

      ctx.fillStyle = 'rgba(10, 10, 15, 0.18)'
      ctx.fillRect(0, 0, w, h)

      t += 0.004
      const cos = Math.cos(t)
      const sin = Math.sin(t)

      for (const p of pts) {
        const x = p.r * Math.sin(p.phi) * Math.cos(p.theta)
        const y = p.r * Math.sin(p.phi) * Math.sin(p.theta)
        const z = p.r * Math.cos(p.phi)
        const xr = x * cos - z * sin
        const zr = x * sin + z * cos
        const depth = (zr + 1.5) / 3
        const sx = cx + xr * scale
        const sy = cy + y * scale
        const size = (1.2 + depth * 2.4) * dpr
        ctx.fillStyle = `hsla(${p.hue}, 70%, ${40 + depth * 30}%, ${0.3 + depth * 0.6})`
        ctx.beginPath()
        ctx.arc(sx, sy, size, 0, Math.PI * 2)
        ctx.fill()
      }

      raf = requestAnimationFrame(frame)
    }
    frame()

    return () => {
      cancelAnimationFrame(raf)
      window.removeEventListener('resize', resize)
    }
  }, [])

  return (
    <section className="relative px-6 md:px-12 pt-12 pb-8 flex flex-col items-center">
      <canvas
        ref={canvasRef}
        className="absolute inset-0 w-full h-full opacity-70 pointer-events-none"
        aria-hidden="true"
      />
      <div className="relative max-w-4xl text-center">
        <p className="font-mono text-xs tracking-widest text-[var(--color-accent)] mb-6 uppercase">
          phone selfie → textured 3d model
        </p>
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-medium tracking-tight leading-[0.95] mb-6">
          one photo.<br />
          <span className="bg-gradient-to-r from-[var(--color-accent)] to-[var(--color-accent-2)] bg-clip-text text-transparent">
            rotable in 60s.
          </span>
        </h1>
        <p className="text-lg md:text-xl text-[var(--color-muted)] max-w-2xl mx-auto">
          take a photo. get a 3D model you can rotate, zoom, and share.
          tencent hunyuan3d-2 + browser GPU. open source.
        </p>
      </div>
    </section>
  )
}
